import { ApiResponse, RoundResultsApiResponse, UpdateResponse, ExtraDataField, QuickImportResponse } from './types';

export async function fetchPlayers(roundId: number, apiUrl?: string): Promise<ApiResponse> {
  const baseUrl = apiUrl || window.location.origin;

  try {
    const response = await fetch(`${baseUrl}/api/dolf-players?round=${roundId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      cache: 'no-store',
    });

    if (!response.ok) {
      throw new Error('Failed to fetch players');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching players:', error);
    throw error;
  }
}

export async function fetchRoundResults(roundId: number, apiUrl?: string): Promise<RoundResultsApiResponse> {
  const baseUrl = apiUrl || window.location.origin;

  try {
    const response = await fetch(`${baseUrl}/api/dolf-results?round=${roundId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      cache: 'no-store',
    });

    if (!response.ok) {
      throw new Error('Failed to fetch round results');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching round results:', error);
    throw error;
  }
}

export async function updatePlayerExtraData(
  roundId: number,
  playerId: number,
  extraData: Record<string, unknown>,
  apiUrl?: string
): Promise<UpdateResponse> {
  const baseUrl = apiUrl || window.location.origin;

  try {
    const response = await fetch(`${baseUrl}/api/dolf-players/update-extra-data`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        round_id: roundId,
        player_id: playerId,
        extra_data: extraData,
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to update player data');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error updating player data:', error);
    throw error;
  }
}

export async function updateExtraFields(
  roundId: number,
  extraFields: ExtraDataField[],
  apiUrl?: string
): Promise<{ success: boolean; round_id: number; extra_fields: ExtraDataField[] }> {
  const baseUrl = apiUrl || window.location.origin;

  try {
    const response = await fetch(`${baseUrl}/api/dolf-tournament/update-extra-fields`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        round_id: roundId,
        extra_fields: extraFields,
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to update extra fields');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error updating extra fields:', error);
    throw error;
  }
}

export async function updatePlayerRegistered(
  roundId: number,
  playerId: number,
  registered: number,
  apiUrl?: string
): Promise<UpdateResponse> {
  const baseUrl = apiUrl || window.location.origin;

  try {
    const response = await fetch(`${baseUrl}/api/dolf-players/update-registered`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        round_id: roundId,
        player_id: playerId,
        registered: registered,
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to update player registration');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error updating player registration:', error);
    throw error;
  }
}

export async function deletePlayer(
  roundId: number,
  playerId: number,
  apiUrl?: string
): Promise<UpdateResponse> {
  const baseUrl = apiUrl || window.location.origin;

  try {
    const response = await fetch(`${baseUrl}/api/dolf-players/delete`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        round_id: roundId,
        player_id: playerId,
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to delete player');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error deleting player:', error);
    throw error;
  }
}

export async function quickImportPlayers(
  roundId: number,
  apiUrl?: string
): Promise<QuickImportResponse> {
  const baseUrl = apiUrl || window.location.origin;

  try {
    const response = await fetch(`${baseUrl}/api/dolf-players/quick-import`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        round_id: roundId,
      }),
    });

    const data = await response.json() as QuickImportResponse;

    if (!response.ok) {
      throw new Error(data.error || 'Failed to run quick import');
    }

    return data;
  } catch (error) {
    console.error('Error running quick import:', error);
    throw error;
  }
}
